import { render, staticRenderFns } from "./VueSelectize.vue?vue&type=template&id=10288aca&scoped=true&lang=html&"
import script from "./VueSelectize.vue?vue&type=script&lang=js&"
export * from "./VueSelectize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10288aca",
  null
  
)

export default component.exports